import { render, staticRenderFns } from "./MenuItemGroup.vue?vue&type=template&id=6fd738d8&scoped=true"
import script from "./MenuItemGroup.vue?vue&type=script&lang=js"
export * from "./MenuItemGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd738d8",
  null
  
)

export default component.exports